@import '../../app-brand/entities/entity-layer.module.less';

.table {
  table-layout: fixed;
  width: 100%;
  border: 1px solid @split-ship-table--border-color;
  border-radius: 4px;
  border-spacing: 0;
}
